import { Component, OnInit, Injector, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  template: '',
})
export class BaseModalComponent implements OnInit, OnDestroy {
  public dialogLoading: boolean;

  public ref: MatDialogRef<BaseModalComponent>;
  public data: any;

  constructor(injector: Injector) {
    this.dialogLoading = false;

    this.ref = injector.get(MatDialogRef);
    this.data = injector.get(MAT_DIALOG_DATA);
  }

  protected startLoading(): void {
    this.dialogLoading = true;
  }

  protected stopLoading(): void {
    this.dialogLoading = false;
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}

  public close(result?: any): void {
    if (!this.dialogLoading) {
      this.ref.close(result);
    }
  }
}
